import React from "react";

const ReportsPopup = ({
                          closePopup,
                          handleDownloadCsv,
                          openVoluumFilePopup,
                          openBulkLookupPopup,
                          openAffisePopup,
                          openEmlPopup,
                          openBbPopup,
                          isDataAvailable,
                          affiseButtonEnabled,
                          selectedANType
                      }) => {
    return (
        <div className="add-item-popup-container">
            <div className="add-item-popup-block">
                <div className="form-wrap">
                    <div className="title-wrap">
                        <h1>Reports</h1>
                        <div className="close-btn" onClick={closePopup}>
                            <img
                                src={`${process.env.PUBLIC_URL}/images/close-btn.svg`}
                                alt="close popup"
                            />
                        </div>
                    </div>

                    <div className="form-flex-container">
                        <div className="popup-buttons-block"
                             style={{display: "flex", flexDirection: "column", gap: 12}}>
                            <button
                                className={`blue-btn ${!isDataAvailable ? "disabled" : ""}`}
                                onClick={handleDownloadCsv}
                                disabled={!isDataAvailable}
                            >
                                Download CSV - All data
                            </button>

                            <button
                                className={`blue-btn ${!isDataAvailable ? "disabled" : ""}`}
                                onClick={openVoluumFilePopup}
                                disabled={!isDataAvailable}
                            >
                                Download CSV - Voluum format
                            </button>

                            <button
                                className={`blue-btn ${!isDataAvailable ? "disabled" : ""}`}
                                onClick={openBulkLookupPopup}
                                disabled={!isDataAvailable}
                            >
                                Bulk Lookup
                            </button>

                            {affiseButtonEnabled && (
                                <button
                                    className={`blue-btn ${!isDataAvailable ? "disabled" : ""}`}
                                    onClick={openAffisePopup}
                                    disabled={!isDataAvailable}
                                >
                                    Affise
                                </button>
                            )}

                            <button
                                className={`blue-btn ${!isDataAvailable ? "disabled" : ""}`}
                                onClick={openEmlPopup}
                                disabled={!isDataAvailable}
                            >
                                Download CSV - EML format
                            </button>

                            <button
                                className={`blue-btn ${!isDataAvailable ? "disabled" : ""}`}
                                onClick={openBbPopup}
                                disabled={!isDataAvailable}
                            >
                                Download CSV - BB format
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReportsPopup;
